import { BaseConstWebappUrl } from '@soundxyz/utils/constants/embeds';
import type { Pathname } from '@components/main-components/link/AccessibleLink';
import type { ParamsValues } from '@context/params';

const baseUrl = typeof window === 'undefined' ? BaseConstWebappUrl : window.location.href;

export function webappUriPath(
  url: string | URL,
  { subpath, params }: { subpath?: Pathname; params?: ParamsValues | null } = {},
): Pathname {
  const urlObj = new URL(url, baseUrl);

  if (subpath) {
    urlObj.pathname = (urlObj.pathname + subpath).replace(/([^:]\/)\/+/g, '$1');
  }

  if (params) {
    for (const [paramKey, paramValue] of Object.entries(params)) {
      if (paramValue === null) {
        urlObj.searchParams.delete(paramKey);
      } else if (paramValue) {
        urlObj.searchParams.set(paramKey, paramValue);
      }
    }
  }

  return (urlObj.pathname + urlObj.search) as Pathname;
}

export function KeepCurrentBrowserHost(url: string | URL) {
  const urlObj = new URL(url);

  if (typeof window !== 'undefined') {
    urlObj.host = new URL(window.location.href).host;
  }

  return urlObj;
}

export const getMarketPlaceUrl = (
  releaseMarketPlaceUrl: string | null,
  contractAddress: string,
  contractChainId: number,
) => {
  return contractChainId === 5
    ? `https://testnets.reservoir.tools/goerli/collection/${contractAddress}`
    : releaseMarketPlaceUrl;
};
